import { Box, Button, Chip, Stack } from '@mui/material';

type Props = {
  readOnly?: boolean;
  isDirty: boolean;
  isSaving?: boolean;
  onSave: () => void;
  onCancel: () => void;
  saveLabel?: string;
  children?: React.ReactNode;
};

export function LoanSectionFormFooter({
  readOnly,
  isDirty,
  isSaving = false,
  onSave,
  onCancel,
  saveLabel = 'Save section',
  children,
}: Props) {
  if (readOnly) return null;

  return (
    <Box
      sx={{
        mt: 3,
        pt: 2,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={1}
        alignItems={{ xs: 'stretch', sm: 'center' }}
        flexWrap="wrap"
        useFlexGap
      >
        {children}
        <Box sx={{ flex: 1, minWidth: 8 }} />
        {isDirty ? (
          <Chip
            size="small"
            label="Unsaved changes"
            color="warning"
            variant="outlined"
          />
        ) : (
          <Chip size="small" label="Saved" color="success" variant="outlined" />
        )}
        <Button
          variant="outlined"
          disabled={isSaving || !isDirty}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={isSaving || !isDirty}
          onClick={onSave}
        >
          {isSaving ? 'Saving…' : saveLabel}
        </Button>
      </Stack>
    </Box>
  );
}
